export const environment = {
  production: true,
  didlookup_endpoint: 'http://dev.nira-inc.com/did-lookup',
  didresolve_endpoint: 'http://dev.nira-inc.com/did-backend',
  epcid: 'did:epc:id:sgtin:0000000.000000.0001',
  epcis_endpoint: 'http://dev.nira-inc.com/epcis/query',
  // epcis_masterdata_endpoint: 'http://dev.nira-inc.com/epcis/query'
  // epcis_masterdata_endpoint: 'https://demo.nira-inc.com/epcis/Service/Poll/SimpleMasterDataQuery?format=JSON&includeAttributes=true&includeChildren=true&HASATTR=bizLocationName'
};
